var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"position-button",attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{attrs:{"color":"#000","size":"18px"}},[_vm._v(" mdi-close ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }